import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Stepper, Step, Box, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GreenStepLabel, globalColor } from 'views/ConstantColors';
import BankingDetails from './BankingDetails';
import PerdiemReceiptDetails from './PerdiemReceiptDetails';
import AcquittalForm from './AcquittalForm';
import FileProofUpload from './FileUpload';

const FormWrapper = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { requestId } = useParams();

    // States
    const [activeStep, setActiveStep] = useState(0);

    const steps = [
        {
            label: 'Banking Details',
            completed: true // This step is always considered completed
        },
        {
            label: 'Perdiem Receipt',
            completed: false
        },
        {
            label: 'Perdiem Acquittal Form',
            completed: false
        },
        {
            label: 'Reports & Attachment',
            completed: false
        }
    ];

    // Navigation handlers
    const handleNext = () => {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    };

    const handleBack = () => {
        setActiveStep((prev) => Math.max(prev - 1, 0));
    };

    // Render current step
    const renderStep = () => {
        switch (activeStep) {
            case 0:
                return <BankingDetails onNext={handleNext} />;
            case 1:
                return <PerdiemReceiptDetails requestId={requestId} onNext={handleNext} onBack={handleBack} />;
            case 2:
                return <AcquittalForm requestId={requestId} onNext={handleNext} onBack={handleBack} />;
            case 3:
                return <FileProofUpload requestId={requestId} onBack={handleBack} />;
            default:
                return null;
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ width: '100%', mb: 4 }}>
                <Stepper
                    activeStep={activeStep}
                    orientation={isMobile ? 'vertical' : 'horizontal'}
                    sx={{
                        py: 3,
                        '& .MuiStepLabel-root .Mui-completed': {
                            color: globalColor
                        }
                    }}
                >
                    {steps.map(({ label, completed }) => (
                        <Step key={label} completed={completed}>
                            <GreenStepLabel>{label}</GreenStepLabel>
                        </Step>
                    ))}
                </Stepper>
                {renderStep()}
            </Box>
        </Container>
    );
};

export default FormWrapper;
